/* eslint-disable max-len */
import React from 'react';

function IndividualIcon() {
  return (
    <svg
      width="35"
      height="33"
      viewBox="0 0 35 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 6.25L32.5962 10.5632C33.2887 10.7611 33.8979 11.1791 34.3317 11.7541C34.7654 12.3291 35 13.0298 35 13.75V30C35 30.3283 34.9353 30.6534 34.8097 30.9567C34.6841 31.26 34.4999 31.5356 34.2678 31.7678C34.0356 31.9999 33.76 32.184 33.4567 32.3097C33.1534 32.4353 32.8283 32.5 32.5 32.5H17.5V6.25Z"
        fill="#0077CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 0H15C15.3283 0 15.6534 0.0646785 15.9567 0.190315C16.26 0.315952 16.5356 0.500085 16.7678 0.732231C16.9999 0.964378 17.1841 1.23996 17.3097 1.54327C17.4353 1.84659 17.5 2.1717 17.5 2.5V32.5H2.5C2.1717 32.5 1.84661 32.4353 1.54329 32.3097C1.23998 32.184 0.964378 31.9999 0.732231 31.7678C0.500085 31.5356 0.315933 31.26 0.190296 30.9567C0.0646595 30.6534 -1.64152e-07 30.3283 0 30V2.5C-1.64152e-07 2.1717 0.0646595 1.84659 0.190296 1.54327C0.315933 1.23996 0.500085 0.964378 0.732231 0.732231C0.964378 0.500085 1.23998 0.315952 1.54329 0.190315C1.84661 0.0646785 2.1717 -1.64152e-07 2.5 0Z"
        fill="#41A5EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.25 12.5C20.5596 12.5 20 13.0597 20 13.75C20 14.4404 20.5596 15 21.25 15H23.75C24.4404 15 25 14.4404 25 13.75C25 13.0597 24.4404 12.5 23.75 12.5H21.25Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.75 12.5C28.0596 12.5 27.5 13.0597 27.5 13.75C27.5 14.4404 28.0596 15 28.75 15H31.25C31.9404 15 32.5 14.4404 32.5 13.75C32.5 13.0597 31.9404 12.5 31.25 12.5H28.75Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.25 16.25C20.5596 16.25 20 16.8097 20 17.5C20 18.1904 20.5596 18.75 21.25 18.75H23.75C24.4404 18.75 25 18.1904 25 17.5C25 16.8097 24.4404 16.25 23.75 16.25H21.25Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.75 16.25C28.0596 16.25 27.5 16.8097 27.5 17.5C27.5 18.1904 28.0596 18.75 28.75 18.75H31.25C31.9404 18.75 32.5 18.1904 32.5 17.5C32.5 16.8097 31.9404 16.25 31.25 16.25H28.75Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.25 20C20.5596 20 20 20.5597 20 21.25C20 21.9404 20.5596 22.5 21.25 22.5H23.75C24.4404 22.5 25 21.9404 25 21.25C25 20.5597 24.4404 20 23.75 20H21.25Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.75 20C28.0596 20 27.5 20.5597 27.5 21.25C27.5 21.9404 28.0596 22.5 28.75 22.5H31.25C31.9404 22.5 32.5 21.9404 32.5 21.25C32.5 20.5597 31.9404 20 31.25 20H28.75Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.75 25C23.0597 25.0001 22.5001 25.5597 22.5 26.25V32.5H30V26.25C29.9999 25.5597 29.4403 25.0001 28.75 25H23.75Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 6.25C5.91848 6.25 5.60054 6.38171 5.36612 6.61613C5.1317 6.85056 5 7.16848 5 7.5C5 7.83152 5.1317 8.14944 5.36612 8.38387C5.60054 8.61829 5.91848 8.75 6.25 8.75H11.25C11.5815 8.75 11.8995 8.61829 12.1339 8.38387C12.3683 8.14944 12.5 7.83152 12.5 7.5C12.5 7.16848 12.3683 6.85056 12.1339 6.61613C11.8995 6.38171 11.5815 6.25 11.25 6.25H6.25Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 12.5C5.91848 12.5 5.60054 12.6317 5.36612 12.8661C5.1317 13.1006 5 13.4185 5 13.75C5 14.0815 5.1317 14.3994 5.36612 14.6339C5.60054 14.8683 5.91848 15 6.25 15H11.25C11.5815 15 11.8995 14.8683 12.1339 14.6339C12.3683 14.3994 12.5 14.0815 12.5 13.75C12.5 13.4185 12.3683 13.1006 12.1339 12.8661C11.8995 12.6317 11.5815 12.5 11.25 12.5H6.25Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 18.75C5.91848 18.75 5.60054 18.8817 5.36612 19.1161C5.1317 19.3506 5 19.6685 5 20C5 20.3315 5.1317 20.6494 5.36612 20.8839C5.60054 21.1183 5.91848 21.25 6.25 21.25H11.25C11.5815 21.25 11.8995 21.1183 12.1339 20.8839C12.3683 20.6494 12.5 20.3315 12.5 20C12.5 19.6685 12.3683 19.3506 12.1339 19.1161C11.8995 18.8817 11.5815 18.75 11.25 18.75H6.25Z"
        fill="#D7EEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 25C5.91848 25 5.60054 25.1317 5.36612 25.3661C5.1317 25.6006 5 25.9185 5 26.25C5 26.5815 5.1317 26.8994 5.36612 27.1339C5.60054 27.3683 5.91848 27.5 6.25 27.5H11.25C11.5815 27.5 11.8995 27.3683 12.1339 27.1339C12.3683 26.8994 12.5 26.5815 12.5 26.25C12.5 25.9185 12.3683 25.6006 12.1339 25.3661C11.8995 25.1317 11.5815 25 11.25 25H6.25Z"
        fill="#D7EEFE"
      />
    </svg>
  );
}

export default IndividualIcon;
